import React from 'react';

import TopBar from '../../components/TopBar';
import Refresh from '../../containers/Refresh';
import RoomsTopBarFilter from './RoomsTopBarFilter';


const {
  ActionsLeft,
  ActionsRight,
} = TopBar;

const RoomsTopBar = function RoomsTopBar() {
  return (
    <TopBar>
      <ActionsLeft>
        <RoomsTopBarFilter />
      </ActionsLeft>
      <ActionsRight>
        <Refresh />
      </ActionsRight>
    </TopBar>
  );
};

export default RoomsTopBar;



// WEBPACK FOOTER //
// ./src/views/rooms/RoomsTopBar.js